import { render, staticRenderFns } from "./TabCobFaixa.vue?vue&type=template&id=cfa25398&"
import script from "./TabCobFaixa.vue?vue&type=script&lang=js&"
export * from "./TabCobFaixa.vue?vue&type=script&lang=js&"
import style0 from "./TabCobFaixa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports